import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'

export default function PastTherapyReportDialog({ bookedEvent, closeDialog }) {
  return (
    <>
      <DialogTitle>Past therapies of {bookedEvent?.userName}</DialogTitle>
      <DialogContent>
        <LSPastVisitReportsComponent
          skeletonNumber={2}
          hidePrintButton
          showOnlyTherapies
          patientId={bookedEvent?.patientId}
          referenceBookedEventId={bookedEvent?.id}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => closeDialog()}>Close</Button>
      </DialogActions>
    </>
  )
}
